var _style, _defs, _mask, _g, _defs2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotRegisteredBankAccountNumberRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 24",
    style: {
      enableBackground: "new 0 0 36 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_2949_34227_00000098936638527421898510000002554744405379746494_);}\r\n\t.st2{fill:#15B79E;}\r\n\t.st3{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter_00000080914405531511771960000008848170048712844180_);}\r\n\t.st4{mask:url(#mask0_3560_28526_00000023965465996361145810000006215675916032598147_);}\r\n\t.st5{fill:#F59E0B;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 2.7,
    y: 3.1,
    width: 17.9,
    height: 17.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 2.7,
    y: 3.1,
    width: 17.9,
    height: 17.9,
    id: "mask0_2949_34227_00000098936638527421898510000002554744405379746494_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: 0.1,
    className: "st0",
    width: 23.8,
    height: 23.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.1,18.6h1v-1.2c0.7-0.1,1.4-0.3,2.1-0.8c0.7-0.5,1-1.2,1-2.1c0-0.7-0.2-1.3-0.6-1.8c-0.4-0.5-1.2-1-2.4-1.4 c-1.1-0.4-1.8-0.7-2.1-1c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.9,0.6-1.3c0.4-0.3,0.9-0.5,1.6-0.5c0.5,0,0.9,0.1,1.3,0.3 c0.3,0.2,0.6,0.5,0.8,0.9l0.9-0.3c-0.2-0.5-0.6-0.9-1-1.2c-0.5-0.3-0.9-0.5-1.5-0.5V5.4h-1v1.2c-0.9,0.1-1.5,0.5-2,1 C8.7,8.1,8.5,8.6,8.5,9.2c0,0.7,0.2,1.3,0.7,1.7c0.4,0.4,1.2,0.8,2.3,1.2c1.1,0.4,1.8,0.7,2.2,1.1c0.4,0.3,0.6,0.8,0.6,1.3 c0,0.7-0.3,1.2-0.8,1.5c-0.5,0.3-1.1,0.5-1.6,0.5c-0.6,0-1.1-0.2-1.5-0.5c-0.5-0.3-0.8-0.8-1.1-1.4L8.2,15c0.3,0.7,0.7,1.2,1.1,1.6 c0.5,0.4,1.1,0.6,1.7,0.8V18.6z M11.6,20.9c-1.2,0-2.4-0.2-3.5-0.7c-1.1-0.5-2-1.1-2.8-1.9c-0.8-0.8-1.4-1.8-1.9-2.8 c-0.5-1.1-0.7-2.2-0.7-3.5s0.2-2.4,0.7-3.5c0.5-1.1,1.1-2,1.9-2.8C6.1,4.9,7,4.2,8.1,3.8c1.1-0.5,2.2-0.7,3.5-0.7s2.4,0.2,3.5,0.7 c1.1,0.5,2,1.1,2.8,1.9c0.8,0.8,1.4,1.8,1.9,2.8c0.5,1.1,0.7,2.2,0.7,3.5s-0.2,2.4-0.7,3.5c-0.5,1.1-1.1,2-1.9,2.8 c-0.8,0.8-1.8,1.4-2.8,1.9C14,20.7,12.9,20.9,11.6,20.9z M11.6,19.9c2.2,0,4.1-0.8,5.6-2.3c1.5-1.5,2.3-3.4,2.3-5.6 c0-2.2-0.8-4.1-2.3-5.6s-3.4-2.3-5.6-2.3C9.4,4.1,7.5,4.8,6,6.4S3.7,9.8,3.7,12c0,2.2,0.8,4.1,2.3,5.6C7.5,19.2,9.4,19.9,11.6,19.9 z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000050625444409823406720000008799559775148094884_",
    filterUnits: "userSpaceOnUse",
    x: 18.8,
    y: 4.8,
    width: 14.3,
    height: 14.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 18.8,
    y: 4.8,
    width: 14.3,
    height: 14.3,
    id: "mask0_3560_28526_00000023965465996361145810000006215675916032598147_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    style: {
      fill: "#D9D9D9",
      filter: "url(#Adobe_OpacityMaskFilter_00000050625444409823406720000008799559775148094884_)"
    },
    width: 20,
    height: 20
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.1,16.4c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.2,0.1,0.3,0.2,0.4C25.7,16.3,25.9,16.4,26.1,16.4z M25.6,13.6h0.8 c0-0.4,0.1-0.7,0.2-0.9c0.1-0.2,0.3-0.4,0.5-0.6c0.5-0.5,0.8-0.9,1-1.2c0.2-0.3,0.2-0.6,0.2-0.9c0-0.6-0.2-1.2-0.6-1.6 s-0.9-0.7-1.6-0.7c-0.5,0-1,0.1-1.4,0.4c-0.4,0.3-0.8,0.7-1,1.1l0.7,0.3c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.2,0.6-0.2,0.9-0.2 c0.5,0,0.9,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.5-0.7,0.7c-0.4,0.3-0.6,0.7-0.7,1 C25.7,12.8,25.6,13.2,25.6,13.6z M26,19.2c-1,0-1.9-0.2-2.8-0.6s-1.6-0.9-2.3-1.5c-0.7-0.7-1.2-1.4-1.5-2.3 C19,13.9,18.8,13,18.8,12c0-1,0.2-1.9,0.6-2.8c0.4-0.9,0.9-1.6,1.5-2.3c0.7-0.7,1.4-1.2,2.3-1.5C24.1,5,25,4.8,26,4.8 c1,0,1.9,0.2,2.8,0.6c0.9,0.4,1.6,0.9,2.3,1.5c0.7,0.7,1.2,1.4,1.5,2.3c0.4,0.9,0.6,1.8,0.6,2.8c0,1-0.2,1.9-0.6,2.8 c-0.4,0.9-0.9,1.6-1.5,2.3c-0.7,0.7-1.4,1.2-2.3,1.5C27.9,19,27,19.2,26,19.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRegisteredBankAccountNumberRegistryIcon);
export default __webpack_public_path__ + "static/media/not-registered-bank-account-number-registry-icon.3bac1e8f30d9cb8dab1a5478f9eef537.svg";
export { ForwardRef as ReactComponent };